import TrackWrapper from '~/components/common/TrackWrapper';
import HighlightBanner from '../../common/HighlightBanner/HighlightBanner';

export default function EvInspectionBanner() {
  return (
    <TrackWrapper event={{ eventName: 'Viewed - Ev Inspection Banner' }}>
      <HighlightBanner
        title="From battery to bumper, get your EV inspected"
        subtitle="No matter where you buy your used EV or how confident you are in the manufacturer, verify the vehicle’s inspection details before purchase. All Carvana vehicles go through vehicle quality inspection so that you can feel confident in the quality of your car."
      />
    </TrackWrapper>
  );
}
